import { useSelector } from 'react-redux';
import CartItem from './CartItem';
import PriceSidebar from './PriceSidebar';
import { useNavigate } from 'react-router-dom';
import Stepper from './Stepper';
import MetaData from '../Layouts/MetaData';
import { Box, Container, Grid, Paper, Typography, Button, List, ListItem } from '@mui/material';

const OrderConfirm = () => {

    const navigate = useNavigate();
    const { cartItems } = useSelector((state) => state.cart);
    const { user } = useSelector((state) => state.user);

    return (
        <>
            <MetaData title="Flipkart: Order Confirmation" />

            <Container maxWidth="lg" sx={{ mt: 12, mb: 4 }}>
			<Grid container spacing={4}>
				<Grid item xs={12} md={8}>
					<Paper elevation={3} sx={{ p: 3, bgcolor: 'background.paper' }}>
						<Stepper activeStep={2}>
							<Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
								Order Confirmation
							</Typography>
							<List>
								{cartItems?.map((item, i) => (
									<ListItem key={i} sx={{ py: 1 }}>
										<CartItem {...item} inCart={false} />
									</ListItem>
								))}
							</List>
							<Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<Typography variant="subtitle1">
									Order confirmation email will be sent to <span style={{ fontWeight: 'bold' }}>{user.email}</span>
								</Typography>
								<Button
									variant="contained"
									color="primary"
									onClick={() => {
										navigate('/process/payment');
									}}
								>
									Continue to Payment
								</Button>
							</Box>
						</Stepper>
					</Paper>
				</Grid>

                    <Grid item xs={12} md={4}>
                        <PriceSidebar cartItems={cartItems} showDeliveryCharge={true} />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default OrderConfirm;
